export const SHOW_NOTICE = 'SHOW_NOTICE';
export const CLOSE_NOTICE = 'CLOSE_NOTICE';